import React from 'react';
import clsx from 'clsx';

import './PromoCard.scss';

type PromoCardProps = {
  badgeText?: string;
  title: string;
  subtitle?: string;
  className?: string;
};

const PromoCard: React.FC<PromoCardProps> = ({ badgeText, title, subtitle, className }) => {
  return (
    <div className={clsx('promo-card', className)}>
      {badgeText && <div className="promo-card__badge">{badgeText}</div>}
      <div className="promo-card__title">{title}</div>
      {subtitle && <div className="promo-card__subtitle">{subtitle}</div>}
    </div>
  );
};

export default PromoCard;
